var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClipboardMagnifyingGlass = function SvgClipboardMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M20.24 3.513c8.974 0 16.25 7.275 16.25 16.25s-7.276 16.25-16.25 16.25c-8.976 0-16.25-7.275-16.25-16.25s7.274-16.25 16.25-16.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.836 10.038V30.9c0 .975-.78 1.755-1.755 1.755H8.898c-.975 0-1.754-.78-1.754-1.755V10.038c0-.974.78-1.754 1.754-1.754h16.168c.975 0 1.755.78 1.755 1.754z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F6",
    d: "M26.836 10.038V30.9c0 .975-.78 1.755-1.755 1.755h-8.084V8.284h8.084c.975 0 1.755.78 1.755 1.754"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7EB",
    d: "M25.824 28.441c0 .48-.39.885-.885.885H10.42a.887.887 0 0 1-.885-.885c0-.495.39-.885.885-.885h14.533c.48 0 .885.39.885.885z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M25.831 28.443c0 .48-.39.885-.885.885h-7.964v-1.755h7.964c.48 0 .885.39.885.885z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7EB",
    d: "M23.484 24.691c0 .48-.39.885-.885.885H10.421a.887.887 0 0 1-.885-.885c0-.495.39-.885.885-.885h12.178c.48 0 .885.39.885.885"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M23.491 24.693c0 .48-.39.885-.884.885h-5.625v-1.755h5.625c.48 0 .884.39.884.885z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7EB",
    d: "M23.484 20.941c0 .48-.39.885-.885.885H10.421a.887.887 0 0 1-.885-.885c0-.495.39-.885.885-.885h12.178c.48 0 .885.39.885.885"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M23.491 20.943c0 .48-.39.885-.884.885h-5.625v-1.755h5.625c.48 0 .884.39.884.885z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M13.704 14.913h-.524v-.525c0-.48-.39-.885-.885-.885a.877.877 0 0 0-.885.885v.525h-.525c-.48 0-.885.39-.885.885s.39.885.885.885h.525v.525c0 .48.39.885.885.885s.885-.39.885-.885v-.525h.524c.48 0 .885-.39.885-.885a.877.877 0 0 0-.885-.885"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7EB",
    d: "M23.018 15.756c0 .495-.39.915-.885.915h-5.16c-.48 0-.884-.405-.884-.915s.39-.914.885-.914h5.159c.48 0 .885.404.885.914"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M23.027 15.753c0 .495-.39.915-.885.915h-5.16v-1.814h5.16c.48 0 .884.405.884.914z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M25.057 7.405H8.89a2.643 2.643 0 0 0-2.64 2.64v20.862a2.643 2.643 0 0 0 2.64 2.64h16.167a2.643 2.643 0 0 0 2.64-2.64V10.03a2.643 2.643 0 0 0-2.64-2.64zm.885 23.487c0 .48-.39.884-.885.884H8.89a.886.886 0 0 1-.885-.884V10.03c0-.48.39-.885.885-.885h16.167c.48 0 .885.39.885.885z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#00484E",
    d: "M27.706 10.03v20.862a2.643 2.643 0 0 1-2.64 2.64h-8.084v-1.756h8.084c.48 0 .885-.39.885-.884V10.03c0-.48-.39-.885-.885-.885h-8.084V7.39h8.084a2.643 2.643 0 0 1 2.64 2.64"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M22.073 6.767V9.75c0 .975-.78 1.755-1.755 1.755h-6.674c-.975 0-1.754-.78-1.754-1.755V6.767c0-.975.78-1.755 1.754-1.755h6.674c.975 0 1.755.78 1.755 1.755"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M22.082 6.77v2.984c0 .975-.78 1.755-1.755 1.755h-3.345V5h3.345c.975 0 1.755.78 1.755 1.755z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M26.836 34.998a1.875 1.875 0 0 1-1.875-1.875V27.44h1.845s.015.075.03.105c1.005 3.284 0 7.454 0 7.454"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M28.71 27.454v5.684c0 1.035-.84 1.875-1.874 1.875v-7.56z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1F8FA",
    d: "M32.459 22.819a5.626 5.626 0 0 1-5.624 5.624c-3.105 0-5.61-2.52-5.61-5.624 0-3.105 2.52-5.624 5.61-5.624a5.626 5.626 0 0 1 5.624 5.624"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M32.46 22.816a5.626 5.626 0 0 1-5.624 5.624V17.207a5.626 5.626 0 0 1 5.624 5.624z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M26.826 16.304a6.497 6.497 0 0 0-6.494 6.494 6.497 6.497 0 0 0 6.494 6.494 6.497 6.497 0 0 0 6.494-6.494 6.497 6.497 0 0 0-6.494-6.494m0 11.233a4.75 4.75 0 0 1-4.74-4.74 4.75 4.75 0 0 1 4.74-4.739 4.75 4.75 0 0 1 4.74 4.74 4.75 4.75 0 0 1-4.74 4.739"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M33.33 22.817a6.497 6.497 0 0 1-6.494 6.494v-1.755a4.75 4.75 0 0 0 4.74-4.739 4.75 4.75 0 0 0-4.74-4.739v-1.755a6.497 6.497 0 0 1 6.494 6.494"
  })));
};
export default SvgClipboardMagnifyingGlass;